import React from "react";
import { brandVars } from "../lib/format";
import { fileUrl } from "../lib/api";
import { Footer } from "./Brand";

export type PraxisPublic = { name: string; strasse: string; plz: string; ort: string; telefon: string; email: string; slug: string; farbe: string; logo_url?: string | null; testmodus?: boolean };

export function PublicShell({ praxis, children }: { praxis?: PraxisPublic | null; children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col" style={brandVars(praxis?.farbe)}>
      <header className="border-b-4 border-primary bg-surface">
        <div className="mx-auto flex max-w-3xl items-center gap-4 px-4 py-4">
          {praxis?.logo_url ? (
            <img src={fileUrl(praxis.logo_url)} alt={praxis.name} className="h-12 max-w-[180px] object-contain" data-testid="praxis-logo" />
          ) : null}
          <div className="min-w-0">
            <p className="truncate text-h3 font-semibold text-primary" data-testid="praxis-name">{praxis?.name || "…"}</p>
            {praxis && <p className="text-sm text-text-muted">{[praxis.ort, praxis.telefon].filter(Boolean).join(" · ")}</p>}
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-6 sm:py-8">{children}</main>
      <Footer provided />
    </div>
  );
}
